// extracted by mini-css-extract-plugin
export default {"KeyFigureItem":"KeyFigureComponents_KeyFigureItem__+PDBG"};